import { render } from "./FooterMiddle.vue?vue&type=template&id=75979ce2&scoped=true"
import script from "./FooterMiddle.vue?vue&type=script&lang=js"
export * from "./FooterMiddle.vue?vue&type=script&lang=js"

import "./FooterMiddle.vue?vue&type=style&index=0&id=75979ce2&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75979ce2"]])

export default __exports__